export const columnTypes = {
    searchUserAccount: 'search_user_account_id'
};
